import SEO, { localBusinessJsonLd, faqJsonLd } from "@/components/SEO";
import { Hero, WhyAluminium, Models, Colors, Gallery, Faq, ContactForm } from "@/components/Sections";
import { FAQS } from "@/data/siteData";

export default function HomePage() {
    const jsonLd = {
        "@context": "https://schema.org",
        "@graph": [localBusinessJsonLd(), faqJsonLd(FAQS)],
    };
    return (
        <>
            <SEO
                title="Aluminijske ograde po mjeri"
                description="alu-ograde.ba — Moderne aluminijske ograde direktno od proizvođača. 6 modela (LUNAR, STELLAR, ASTRAL, ECLIPSE, ORBIT, GALACTIC), 217 RAL boja, 10 godina garancije, dostava i montaža u cijeloj BiH."
                keywords="aluminijske ograde, alu ograde, alu ograda Tuzla, ograde po mjeri, RAL boje, panel ograda, lamelna ograda, aluminijska kapija BiH"
                jsonLd={jsonLd}
            />
            <Hero />
            <WhyAluminium />
            <Models />
            <Colors />
            <Gallery />
            <Faq />
            <ContactForm />
        </>
    );
}
